/**
 * 提交参数序列化，等同qs.stringify
 * @param {*} value 参数值
 * @param {*} index 下标
 * 
 * @returns string[]，使用join('&')合并参数
 */
export const onEncode = (value = null, index = null) => {
    if (value === null) return [];
    let res = [];
    let type = typeof (value);
    if (type === 'string' || type === 'number' || type === 'boolean' || value instanceof Date) {
        res.push(index === null ? value : `${index}=${encodeURIComponent(value)}`);
    } else if (type === 'object') {
        for (let key in value) {
            res = res.concat(onEncode(value[key], index === null ? key : `${index}[${key}]`));
        }
    }
    return res;
}